import React, { useCallback } from 'react';
import { TopicResponse } from '../../../../types/api/forum';
import { formatDateTime } from '../../../../helpers/dates';
import { Stack, Text, Button, Checkbox, Label } from '@primer/react'
import { ChevronRightIcon, ClockIcon, CommentIcon } from '@primer/octicons-react';

interface TopicViewProps {
    topic: TopicResponse;
    isSelected: boolean
    isDisabled: boolean
    didSelected: (isSelected: boolean) => void
    didDelete: () => void
    didToggleVisibility: () => void
    didOpenTopic: () => void
}

export const TopicView: React.FC<TopicViewProps> = ({ topic, isSelected, isDisabled, didSelected, didDelete, didToggleVisibility, didOpenTopic }) => {

    const handleRowSelect = useCallback((rowId: string, isSelected: boolean) => {
        didSelected(isSelected)
    }, []);

    return (
        <div className="bg-white border border-border rounded-lg w-full">
            <div className="w-full">
                <div className="px-4 mt-4">
                    <Stack justify="space-between" direction="horizontal">
                        <Stack direction="horizontal" align="center">
                            <Stack gap='none'>
                                <Button
                                    onClick={didOpenTopic}
                                    className='!h-[24px] -ml-2'
                                    size="small"
                                    trailingVisual={ChevronRightIcon}
                                    variant="invisible">
                                    <Text
                                        as="span"
                                        weight='medium'
                                        className='text-[14px] text-aloix-black'
                                    >
                                        {topic.title}
                                    </Text>
                                </Button>
                                <Text
                                    as="span"
                                    weight='regular'
                                    className='text-[14px] text-aloix-grey  ml-[2px]'
                                >
                                    {topic.user?.username ?? "\u00A0"}
                                </Text>
                            </Stack>
                        </Stack>
                        <Checkbox
                            checked={isSelected}
                            disabled={isDisabled}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                                handleRowSelect(topic.id, e.target.checked)
                            }
                            aria-label={`Выделить ${topic.title}`}
                        />
                    </Stack>
                </div>
            </div>
            <div className="px-4 mt-4 mb-3">
                <Stack direction="horizontal" justify="space-between" gap="condensed">
                    <Stack direction="horizontal" align="center" gap="condensed">
                        {topic.isHidden && <Label variant='attention' size="small">Скрыта</Label>}
                        <CommentIcon size={16} className='text-aloix-grey' />
                        <Text className='text-[14px] text-aloix-black '>{topic.postsCount}</Text>
                        <ClockIcon size={16} className='text-aloix-grey ml-3' />
                        <Text className='text-[14px] text-aloix-grey'>{formatDateTime(topic.createdAt)}</Text>
                    </Stack>
                    <div></div>
                    <Stack direction="horizontal" gap="condensed">
                        <Button
                            variant="default"
                            disabled={isSelected || isDisabled}
                            onClick={didToggleVisibility}>
                            {topic.isHidden ? 'Показать' : 'Скрыть'}
                        </Button>
                        <Button
                            variant="danger"
                            disabled={isSelected}
                            onClick={didDelete}>
                            Удалить
                        </Button>
                    </Stack>
                </Stack>
            </div>
        </div>
    )
};